import { lazy } from 'react';

const PlansListPage = lazy(() => import('../pages/PlansList.page'));
const PlanFormPage = lazy(() => import('../pages/PlanForm.page'));
const TenantsListPage = lazy(() => import('../pages/TenantsList.page'));
const UpgradeRequestsPage = lazy(() => import('../pages/UpgradeRequests.page'));
const PlatformSettingsPage = lazy(() => import('../pages/PlatformSettings.page'));

const SubscriptionsRoutes = [
    {
        path: '/subscriptions',
        children: [
            { index: true, element: <PlansListPage />, layout: 'default', isAuthReq: true },
            { path: 'plans', element: <PlansListPage />, layout: 'default', isAuthReq: true },
            { path: 'plans/add', element: <PlanFormPage />, layout: 'default', isAuthReq: true },
            { path: 'plans/:id/edit', element: <PlanFormPage />, layout: 'default', isAuthReq: true },
            { path: 'tenants', element: <TenantsListPage />, layout: 'default', isAuthReq: true },
            { path: 'requests', element: <UpgradeRequestsPage />, layout: 'default', isAuthReq: true },
            { path: 'platform-settings', element: <PlatformSettingsPage />, layout: 'default', isAuthReq: true },
        ],
    },
];

export { SubscriptionsRoutes };
